module.exports = __webpack_public_path__ + "fonts/GothamSSm-Book.9f66b831.ttf";